import React from 'react';
import { Text } from 'components/Text';
import { userRoles } from 'types/user';

export const info = [
  {
    title: 'Company Email',
    data: 'boomy@company.com',
    key: 'email',
  },
  {
    title: 'Company Name',
    data: 'Great company',
    key: 'name',
  },
  {
    title: 'Company Phone',
    data: '746748294',
    key: 'phone',
  },
  {
    title: 'Company Website',
    data: 'https://www.google.com',
    key: 'website',
  },
];

export const people = [
  {
    name: 'Stefan Alexiev',
    email: 'boomy@company.com',
    role: 'owner',
  },
  {
    name: 'John Doe',
    email: 'boomboom@mail.com',
    role: 'name',
  },
];

export const columns = [
  {
    name: 'Name',
    id: 1,
    render: (item: any) => (
      <div className="flex items-center">
        <img
          className="mr-4 h-10 w-10 sm:h-10 sm:w-10 rounded-full"
          src={item.user.avatarUrl}
          alt={item.user.displayName}
        />
        {item.user.displayName}
      </div>
    ),
  },
  {
    name: 'Email',
    id: 2,
    render: (item: any) => <Text value={item.user.email} type="sm" />,
  },
  {
    name: 'Role',
    id: 3,
    render: (item: any) => {
      if (item.userEmail === item.user.email || !item.isAdmin) {
        return <Text value={item.role} type="sm" className="px-2 py-1" />;
      }

      const roles = Object.values(userRoles).filter(
        (r) => r !== userRoles.SHIPAID_ADMIN,
      );

      return (
        <div className="flex items-center gap-2">
          <select
            value={item.selectedRole}
            onChange={(e) => item.onRoleChange(e.target.value, false)}
            className="text-sm border border-gray-300 rounded px-2 py-1"
          >
            {roles.map((r) => (
              <option key={r} value={r}>
                {r.charAt(0).toUpperCase() + r.slice(1)}
              </option>
            ))}
          </select>
        </div>
      );
    },
  },
  {
    name: 'Action',
    id: 4,
    render: (item: any) => {
      const shouldSave = item.role !== item.selectedRole;
      return item.userEmail !== item.user.email && item.isAdmin ? (
        <div className="flex gap-2">
          <div
            onClick={() => shouldSave && item.onRoleChange(item.selectedRole)}
            style={{
              visibility: shouldSave ? 'visible' : 'hidden',
            }}
          >
            <Text value="Save" type="sm" className="cursor-pointer" />
          </div>
          <div onClick={item.onRemoveUser}>
            <Text
              value="Remove"
              type="sm"
              className="text-red-500 cursor-pointer"
            />
          </div>
        </div>
      ) : (
        <></>
      );
    },
  },
];

export const invitesColumns = [
  {
    name: 'Email',
    id: 1,
    render: (item: any) => <Text value={item.email} type="sm" />,
  },
  {
    name: 'Role',
    id: 2,
    key: 'role',
  },
  {
    name: 'Date Sent',
    id: 3,
    render: (item: any) => {
      return (
        <Text value={new Date(item.createdAt).toLocaleDateString()} type="sm" />
      );
    },
  },
];
